import { useTheme } from '@emotion/react';
import { type Interpolation, type SpringValue } from '@react-spring/web';
import { useTranslation } from 'next-i18next';
import { SwipeActionsWrapper, AnimatedSwipeActionButton, SWIPE_BUTTON_WIDTH } from './styles';
interface Props {
  progress: SpringValue<number> | Interpolation<number, number>;
  onBlockAndLeave?: () => void;
  onLeave?: () => void;
}
const SwipeActions = ({
  progress,
  onBlockAndLeave,
  onLeave
}: Props) => {
  const {
    t
  } = useTranslation();
  const {
    isRtl
  } = useTheme();
  const direction = isRtl ? -1 : 1;
  return <SwipeActionsWrapper data-sentry-element="SwipeActionsWrapper" data-sentry-component="SwipeActions" data-sentry-source-file="SwipeActions.tsx">
      <AnimatedSwipeActionButton type='button' variant='warning' style={{
      zIndex: 1,
      transform: progress.to(p => {
        const leaveOffset = (SWIPE_BUTTON_WIDTH * 2 * p - SWIPE_BUTTON_WIDTH) * direction;
        return `translateX(${leaveOffset}px)`;
      })
    }} onClick={e => {
      e.stopPropagation();
      onLeave?.();
    }} data-sentry-element="AnimatedSwipeActionButton" data-sentry-source-file="SwipeActions.tsx">
        {t('dm.leave_option')}
      </AnimatedSwipeActionButton>
      <AnimatedSwipeActionButton type='button' variant='danger' style={{
      zIndex: 2,
      transform: progress.to(p => {
        const blockOffset = (SWIPE_BUTTON_WIDTH * p - SWIPE_BUTTON_WIDTH) * direction;
        return `translateX(${blockOffset}px)`;
      })
    }} onClick={e => {
      e.stopPropagation();
      onBlockAndLeave?.();
    }} data-sentry-element="AnimatedSwipeActionButton" data-sentry-source-file="SwipeActions.tsx">
        {t('dm.block_leave_option')}
      </AnimatedSwipeActionButton>
    </SwipeActionsWrapper>;
};
export default SwipeActions;